<template>
  <v-dialog
    v-model="internalValue"
    max-width="1100px"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card>

      <!-- HEADER -->
      <v-card-title class="history-header">
        <v-icon left color="white">mdi-calendar-check</v-icon>
          Tabla de Amortización
        <v-spacer />
      </v-card-title>

      <v-divider />

      <!-- TABLE -->
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="data"
          item-key="id"
          dense
          class="elevation-0"
        >

          <template v-slot:[`item.fechaFin`]="{ item }">
            {{ formatDateShortText(item.fechaFin) }}
          </template>

          <template v-slot:[`item.saldoCapitalVigente`]="{ item }">
            {{ formatCurrency(item.saldoCapitalVigente) }}
          </template>

          <template v-slot:[`item.pagoCapital`]="{ item }">
            {{ formatCurrency(item.pagoCapital) }}
          </template>

          <template v-slot:[`item.pagoInteres`]="{ item }">
            {{ formatCurrency(item.pagoInteres) }}
          </template>

          <template v-slot:[`item.iva`]="{ item }">
            {{ formatCurrency(item.iva) }}
          </template>

          <template v-slot:[`item.montoPago`]="{ item }">
            {{ formatCurrency(item.montoPago) }}
          </template>

          <template v-slot:[`item.paid`]="{ item }">
            {{ item.paid ? 'Sí' : 'No' }}
          </template>

        </v-data-table>
      </v-card-text>

      <v-divider />

      <!-- FOOTER -->
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>

            <!-- Disclaimer -->
            <v-col cols="12" md="7" class="pr-md-4">
            <div class="caption grey--text text--darken-1 font-italic">
                <strong>* Todos los montos están expresados en {{ currency }}.</strong>
            </div>
            <div class="caption grey--text text--darken-1 font-italic">
                Los datos mostrados son de carácter informativo y corresponden a una proyección del crédito.
                Los montos y fechas pueden cambiar si se realizan pagos anticipados, existen variaciones en la tasa de interés u otros ajustes conforme al contrato.
                Para efectos legales, prevalece el contrato de crédito aceptado por el cliente.
            </div>
            </v-col>

            <!-- Actions -->
            <v-col cols="12" md="5" class="d-flex justify-end align-center mt-3 mt-md-0">
            <export-table
                v-if="data.length"
                class="mr-3"
                :fileName="exportFileName"
                :mapFunction="mapFunction"
                :dataToExport="data"
                :headers="excelHeaders"
            />

            <v-btn text color="primary" @click="close">
                Close
            </v-btn>
            </v-col>

        </v-row>
        </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import productMixin from '../../mixins/productMixin'
import ExportTable from '../ExportTable.vue'

export default {
  name: 'AmortizationSchedule',
  mixins: [productMixin],
  components: { ExportTable },
  props: {
    value: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
    folio: { type: String, default: '' },
    currency: { type: String, default: '' }
  },

  data () {
    return {
      headers: [
        { text: 'Periodo', value: 'periodo', align: 'center' },
        { text: 'Fecha de fin', value: 'fechaFin', align: 'center' },
        { text: 'Días', value: 'plazoPeriodo', align: 'center' },
        { text: 'Saldo de capital', value: 'saldoCapitalVigente', align: 'right' },
        { text: 'Pago de capital', value: 'pagoCapital', align: 'right' },
        { text: 'Pago de interés', value: 'pagoInteres', align: 'right' },
        { text: 'I.V.A.', value: 'iva', align: 'right' },
        { text: 'Monto del pago', value: 'montoPago', align: 'right' },
        { text: 'Pagado', value: 'paid', align: 'center' }
      ],
      excelHeaders: {
        period: 'Periodo',
        endDate: 'Fecha Fin',
        days: 'Días',
        capitalBalance: 'Saldo de Capital',
        capitalPayment: 'Pago de Capital',
        interestPayment: 'Pago de Interés',
        iva: 'I.V.A.',
        payment: 'Monto del Pago',
        paid: 'Pagado'
      }
    }
  },

  methods: {
    close () {
      this.internalValue = false
    },
    mapFunction (item) {
      return Object.assign({
        period: item.periodo,
        endDate: this.formatDateNumeric(item.fechaFin),
        days: item.plazoPeriodo,
        capitalBalance: this.formatCurrency(item.saldoCapitalVigente),
        capitalPayment: this.formatCurrency(item.pagoCapital),
        interestPayment: this.formatCurrency(item.pagoInteres),
        iva: this.formatCurrency(item.iva),
        payment: this.formatCurrency(item.montoPago),
        paid: item.paid ? 'Sí' : 'No'
      })
    }
  },

  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    exportFileName () {
      return `Amortizacion ${this.folio}`
    }
  }
}
</script>

<style scoped>
.link-like {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.history-header {
  background: #324A74;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 16px 20px;
  letter-spacing: .4px;
  display: flex;
  align-items: center;
}
</style>
